/**
 * localStorageAdapter
 *
 * A custom axios adapter that provides the ability to optinoally
 * cache responses for a given period of time.
 *
 * Usage:
 *
 * In the axios config, set {adapters: localStorageAdapter}
 *
 * When making the axios request, add cacheKey and cacheTime
 * properties to the configuration object, i.e.
 *
 *      axios.get('http://www.google.com/search', {
 *          cacheKey: "VEHICLE_12345",
 *          cacheTime: 60 * 5,
 *       })
 *
 */
import LocalStorageCache from "localstorage-cache";
import axios from "axios";

const localStorageCache = new LocalStorageCache(2 * 1024, "LRU");

export default async (config) => {
  const { cacheKey, cacheTime } = config;

  if (!cacheKey || !cacheTime) {
    return axios.defaults.adapter(config);
  }

  const cachedValue = localStorageCache.getCache(config.cacheKey);

  if (cachedValue) {
    return cachedValue;
  }

  const response = await axios.defaults.adapter(config);

  if (response.status >= 200 && response.status < 300) {
    localStorageCache.setCache(
      config.cacheKey,
      {
        data: response.data,
      },
      config.cacheTime,
    );
  }

  return response;
};
